import { castArray, concat, reduce } from 'lodash'

const findLastChildren = node => {
  const { children } = node

  if (!children) {
    return castArray(node)
  }

  return reduce(
    children,
    (result, child) => {
      const lastChildren = findLastChildren(child)

      return concat(result, ...castArray(lastChildren))
    },
    [],
  )
}

export default findLastChildren
